var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"日报"}},[_c('revenue-chart-one')],1),_c('el-tab-pane',{attrs:{"label":"月报"}},[_c('revenue-chart-two')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }